export const DEPLOY_COMMIT_STORAGE_KEY = 'moonscroll_deploy_commit';

/**
 * After a successful /api/v1/user-config/ response, sync localStorage and notify if the
 * server deploy commit changed since the user last acknowledged a deploy.
 */
export function processUserConfigForDeployUpdate(config) {
  const apiCommit = (config?.env?.deploy_commit || '').trim();
  if (!apiCommit) {
    return;
  }

  const stored = localStorage.getItem(DEPLOY_COMMIT_STORAGE_KEY);
  if (!stored) {
    localStorage.setItem(DEPLOY_COMMIT_STORAGE_KEY, apiCommit);
    return;
  }
  if (stored !== apiCommit) {
    window.dispatchEvent(
      new CustomEvent('moonscroll:deploy-update', { detail: { commit: apiCommit } })
    );
  }
}

export function acknowledgeDeployUpdateAndReload(commit) {
  localStorage.setItem(DEPLOY_COMMIT_STORAGE_KEY, commit);
  window.location.reload();
}
